import React from "react";
import { NextPage } from "next";
import CommonLayout from "@src/layouts/CommonLayout";
import { Box, Heading } from "@chakra-ui/react";

const BusinessPage: NextPage = () => {
  return (
    <CommonLayout>
      <Box
        display="flex"
        flexDirection="column"
        m={3}
        mx="auto"
        mb={50}
        maxW={600}
      >
        <Heading
          display="inline-block"
          m={3}
          my={[5, 10]}
          pb={3}
          fontWeight="bold"
          fontSize={24}
          textAlign="center"
          borderBottom="3px solid"
        >
          店舗登録リクエスト
        </Heading>
        <Box>
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSc3cCvX4RxSm4zVEWKprPsSYM6oVh8p2IvGEIJKBrDUWrsJiA/viewform?embedded=true"
            width="100%"
            height={1000}
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
          >
            読み込んでいます…
          </iframe>
        </Box>
      </Box>
    </CommonLayout>
  );
};

export default BusinessPage;
